import React from 'react'
import {Tireset, TireType} from "../../../../domain-models"
import Trans from '../../../../components/Trans'

type Props = {
  tireset: Tireset
  onlyFirst?: boolean
}

const positionMap = {
  1: 'Vorne Links',
  2: 'Vorne Rechts',
  3: 'Hinten Links',
  4: 'Hinten Rechts'
}

const wheelTypes = {
  0: 'Aluminium',
  1: 'Stahl',
}

const wheelCaps = {
  0: 'keine',
  1: 'original',
  2: 'fehlt',
}

const TireData = ({tireset, onlyFirst}: Props) => {

  return (
    <div className={'grid gap-4'}>
      {!tireset.tires || !tireset.tires.length ? <><Trans>Keine Raddaten vorhanden</Trans></> : null}
      {
        tireset.tires ? tireset.tires.map((tire, index) => !onlyFirst || index === 0 ? (
            <div className={'flex flex-col text-gray-900'}>
              <div className={'font-semibold text-xl'}><Trans>Rad</Trans> {tire.Position ? positionMap[tire.Position] : null}</div>
              <div className="mt-2 grid grid-cols-3 gap-2 w-full">
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Marke</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.TireMake || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Profiltiefe</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.TireProfileDepth || '-'} mm</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Typ</Trans></span>
                  <span className={'truncate font-semibold'}>
                    <Trans>{tire.TireType === TireType.ALLWEATHER ? 'Allwetter' : tire.TireType === TireType.WINTER ? 'Winter' : 'Sommer'}-Reifen</Trans>
                  </span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Dot</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.TireDotNumber || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>B/H/Z</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.TireWidth || '-'} / {tire.TireHeight || '-'} / {tire.TireInch || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Zusatzfunktion</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.AdditionalFeature || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}>RDKS</span>
                  <span className={'truncate font-semibold'}><Trans>{tire.Rdks ? 'Ja' : 'Nein'}</Trans></span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Felgenmarke</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.WheelMake || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Felgentyp</Trans></span>
                  <span className={'truncate font-semibold'}>{wheelTypes[tire.WheelType] || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Felgengröße</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.WheelWidth || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Felgenfarbe</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.WheelColor || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Felgenzustand</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.WheelCondition || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Lochkreis</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.WheelHoleCircle || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Einpresstiefe</Trans></span>
                  <span className={'truncate font-semibold'}>{tire.WheelOffset || '-'}</span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Radkappe</Trans></span>
                  <span className={'truncate font-semibold'}><Trans>{wheelCaps[tire.WheelCap] || 'keine'}</Trans></span>
                </div>
                <div className={'flex flex-col'}>
                  <span className={'text-gray-600 text-sm'}><Trans>Originalfelge</Trans></span>
                  <span className={'truncate font-semibold'}><Trans>{tire.WheelIsOriginal ? 'Ja' : 'Nein'}</Trans></span>
                </div>
              </div>
            </div>
          ) : null
        ) : null
      }
    </div>
  )
}


export default TireData

